import {ActionIcon, Button} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {useChecklistData} from "./ChecklistDataContext";
import {useComment} from "./comments/CommentContext";
import CommentIcon from "../../../assets/v2-comment.svg?react";
import FilledCommentIcon from "../../../assets/v2-filled-comment.svg?react";
import {dibAppApi} from "../../../dibAppApi/dibAppApi";

export const CommentButton = ({
    variant = "icon",
    nodeId,
}: {
    variant?: "icon" | "icontext";
    nodeId: string;
}) => {
    const {t} = useTranslation();
    const {collectionData} = useChecklistData();
    const {setFocusedNode} = useComment();

    const collectionId = collectionData?.metadata?.collectionId ?? "";

    const {data: commentsData, isError} = dibAppApi.endpoints.getComments.useQuery(
        {collectionId},
        {skip: !collectionId},
    );

    // Hide the icon when there's no collection or the comments call failed (e.g.
    // the intermittent 500 on a deleted collection) — never paint a broken icon.
    if (!collectionData || isError) return null;

    const hasComment = Boolean(
        commentsData?.elementdata?.[nodeId]?.ci_comments?.length,
    );

    const Icon = hasComment ? FilledCommentIcon : CommentIcon;
    const color = hasComment ? "orange.5" : "gray";

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        setFocusedNode(nodeId, !hasComment);
    };

    if (variant === "icontext") {
        return (
            <Button
                variant="subtle"
                size="compact-sm"
                color={color}
                leftSection={<Icon width={16} height={16} />}
                onClick={handleClick}
            >
                {hasComment ? t("Action.EditComment") : t("Action.AddComment")}
            </Button>
        );
    }

    return (
        <ActionIcon
            variant="subtle"
            size="sm"
            color={color}
            onClick={handleClick}
        >
            <Icon width={16} height={16} />
        </ActionIcon>
    );
};
